// src/components/Pagination.jsx
import React from "react";
import "../assets/css/staff-dashboard.css";

export default function Pagination({ page, total, onChange }) {
  if (total <= 1) return null;
  return (
    <div className="pagination modern">
      <button disabled={page === 1} onClick={() => onChange(page - 1)}>
        ‹
      </button>
      {Array.from({ length: total }, (_, i) => (
        <button
          key={i + 1}
          className={page === i + 1 ? "active" : ""}
          onClick={() => onChange(i + 1)}
        >
          {i + 1}
        </button>
      ))}
      <button disabled={page === total} onClick={() => onChange(page + 1)}>
        ›
      </button>
    </div>
  );
}
